import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'

export function createAddressForm(addr?: any, isRequired = true): UntypedFormGroup {
  return new UntypedFormGroup({
    address: new UntypedFormControl(addr?.address, isRequired ? [Validators.required] : []),
    city: new UntypedFormControl(addr?.city, isRequired ? [Validators.required] : []),
    country: new UntypedFormControl(addr?.country, isRequired ? [Validators.required] : []),
    country_code: new UntypedFormControl(
      addr?.countryCode || addr?.country_code,
      isRequired ? [Validators.required] : []
    ),
    postal_code: new UntypedFormControl(addr?.postalCode || addr?.postal_code, isRequired ? [Validators.required] : []),
    state: new UntypedFormControl(addr?.state, isRequired ? [Validators.required] : []),
  })
}

@Component({
  selector: 'app-address-form',
  templateUrl: './AddressForm.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddressFormComponent implements OnInit {
  @Input() form: UntypedFormGroup

  ngOnInit() {}
}
